(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingDetailController', QuotingDetailController);

    QuotingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Quoting'];

    function QuotingDetailController($scope, $rootScope, $stateParams, previousState, entity, Quoting) {
        var vm = this;

        vm.quoting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:quotingUpdate', function(event, result) {
            vm.quoting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
